import * as S from 'pages/Institutional/style'

const DataLicense = () => (
  <S.Page>
    <S.Container>
      <S.Hero>
        <S.Eyebrow>Políticas RedSterna</S.Eyebrow>
        <S.Title>Política de Licenciamento e Uso de Dados</S.Title>
        <S.Lead>
          Condições para consulta, citação, compartilhamento e utilização das
          estatísticas agregadas disponibilizadas pela RedSterna.
        </S.Lead>
        <S.UpdatedAt>Versão 1.0 · 19/10/2026</S.UpdatedAt>
      </S.Hero>
      <S.Body>
        <S.Section>
          <S.SectionTitle>1. Apresentação e abrangência</S.SectionTitle>
          <S.Paragraph>
            A RedSterna é uma plataforma de descoberta de destinos e
            compartilhamento de experiências e roteiros de viagem. Esta política
            rege os indicadores, estatísticas e compilações agregadas que a
            plataforma produzir ou disponibilizar publicamente.
          </S.Paragraph>
          <S.Paragraph>
            Exemplos incluem quantidade de roteiros públicos por destino,
            duração média e mais frequente de viagens, associações entre
            destinos e tendências agregadas. A existência de informações no site
            não implica autorização irrestrita para reproduzi-las.
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>2. Titularidade e direitos</S.SectionTitle>
          <S.Paragraph>
            A RedSterna reserva os direitos legalmente aplicáveis à seleção,
            organização, estruturação, apresentação e elaboração de suas
            análises e compilações próprias. Dados e fatos isolados não são
            automaticamente protegidos por direitos autorais; a proteção depende
            dos requisitos legais.
          </S.Paragraph>
          <S.Paragraph>
            Esta política não transfere à RedSterna a titularidade dos materiais
            de usuários ou terceiros nem concede direitos de reutilização sobre
            esses materiais.
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>3. Usos permitidos</S.SectionTitle>
          <S.List>
            <li>
              Consulta e utilização pessoal de indicadores públicos para fins
              informativos, educacionais e de planejamento de viagens.
            </li>
            <li>
              Compartilhamento de links e citação pontual de estatísticas
              públicas, inclusive em materiais acadêmicos, jornalísticos e
              comerciais, com atribuição da fonte.
            </li>
            <li>
              Referência a resultados públicos sem sugerir parceria ou endosso
              da RedSterna e sem distorcer seu significado ou contexto.
            </li>
          </S.List>
          <S.Paragraph>
            A reprodução integral de conjuntos de dados e a extração
            automatizada em escala não estão abrangidas por essas permissões.
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>4. Usos sujeitos à autorização</S.SectionTitle>
          <S.Paragraph>
            Salvo quando permitido por lei, exigem autorização prévia a
            reprodução substancial e redistribuição de bases organizadas pela
            RedSterna, a extração sistemática por robôs ou ferramentas
            similares, a criação de bases derivadas por cópia substancial, a
            revenda ou sublicenciamento de conjuntos de dados e a oferta desses
            conjuntos como parte de produtos, serviços ou APIs de terceiros.
          </S.Paragraph>
          <S.Paragraph>
            A utilização comercial pontual de indicadores públicos, nas
            condições da seção 3, não exige autorização apenas por ter
            finalidade comercial.
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>5. Atribuição</S.SectionTitle>
          <S.Paragraph>
            Ao citar dados públicos da plataforma, identifique a fonte como{' '}
            <strong>RedSterna — www.redsterna.com.br</strong>. Sempre que
            possível, inclua o link da página consultada, a data da consulta e o
            destino ou indicador mencionado. A atribuição não substitui
            autorizações exigidas para outros usos.
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>
            6. Privacidade e conteúdo dos usuários
          </S.SectionTitle>
          <S.Paragraph>
            As estatísticas devem ser disponibilizadas de forma agregada e,
            quando aplicável, anonimizada, com medidas para reduzir riscos de
            identificação. A publicação de estatísticas não autoriza acesso a
            dados pessoais, informações privadas de contas ou roteiros privados.
          </S.Paragraph>
          <S.Paragraph>
            O tratamento de dados pessoais segue a Lei Geral de Proteção de
            Dados Pessoais (Lei nº 13.709/2018), a Política de Privacidade e as
            normas aplicáveis. Fotografias, roteiros, comentários, avaliações e
            demais conteúdos de usuários ou terceiros seguem suas respectivas
            titularidades, autorizações e os Termos de Uso.
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>7. Qualidade e atualização</S.SectionTitle>
          <S.Paragraph>
            Os indicadores podem resultar de contribuições de usuários, dados
            públicos, métodos próprios de agregação e processos automatizados.
            São informativos e podem mudar com atualizações, correções ou
            mudanças metodológicas. A RedSterna não garante que sejam completos
            ou adequados para decisões específicas.
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>
            8. Mecanismos de pesquisa e acesso automatizado
          </S.SectionTitle>
          <S.Paragraph>
            A disponibilização de páginas públicas e metadados estruturados para
            mecanismos de pesquisa não representa autorização irrestrita para
            cópia integral, extração sistemática ou exploração comercial de
            conjuntos de dados. A indexação não modifica as condições desta
            política.
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>
            9. Licenças específicas e descumprimento
          </S.SectionTitle>
          <S.Paragraph>
            A RedSterna poderá estabelecer contratos ou licenças específicas
            para relatórios, análises, bases e integrações, observadas as leis e
            os direitos de terceiros. Uso em desacordo com esta política poderá
            resultar nas medidas legalmente cabíveis, inclusive restrições
            técnicas proporcionais a acessos abusivos.
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>10. Alterações e contato</S.SectionTitle>
          <S.Paragraph>
            Esta política poderá ser revisada com a divulgação de nova versão e
            data, com aplicação prospectiva e respeito a direitos e contratos
            vigentes. Dúvidas, solicitações de autorização ou parcerias podem
            ser encaminhadas a{' '}
            <a href="mailto:contato@redsterna.com.br">
              contato@redsterna.com.br
            </a>
            .
          </S.Paragraph>
        </S.Section>
        <S.Section>
          <S.SectionTitle>11. Identificação da licença</S.SectionTitle>
          <S.Paragraph>
            <strong>Nome:</strong> Política de Licenciamento e Uso de Dados —
            RedSterna
          </S.Paragraph>
          <S.Paragraph>
            <strong>Versão:</strong> 1.0 · <strong>Identificador:</strong>{' '}
            Redsterna-Data-License-1.0
          </S.Paragraph>
          <S.Paragraph>
            <strong>URL desta versão:</strong>{' '}
            https://redsterna.com.br/licenca-de-dados/v1
          </S.Paragraph>
          <S.Paragraph>
            Licença própria para consulta, compartilhamento e citação pontual de
            estatísticas públicas, nas condições aqui descritas. Demais direitos
            reservados nos limites da legislação aplicável.
          </S.Paragraph>
        </S.Section>
      </S.Body>
    </S.Container>
  </S.Page>
)

export default DataLicense
